import loginFox from "../assets/onboarding/login-fox.svg";
import onboardingFox from "../assets/onboarding/onboarding-fox.svg";
import wordmark from "../assets/onboarding/wordmark.svg";
import check from "../assets/onboarding/check.svg";
import message from "../assets/onboarding/message.svg";

export const funnelLoginFox = loginFox;
export const funnelOnboardingFox = onboardingFox;
export const funnelWordmark = wordmark;
export const funnelCheck = check;
export const funnelMessage = message;
